// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRequestedRequestUpdateModalStages_root__IMn-U","footer":"CoursePauseRequestedRequestUpdateModalStages_footer__fIF+A"};